<template>
  <q-inner-loading :showing="loading" style="z-index: 5000">
    <q-spinner color="primary" size="3em" />
  </q-inner-loading>
</template>

<script>
/**
 * Loading.
 * Using Quasar Inner Loading.
 * https://quasar.dev/vue-components/inner-loading
 *
 * In order for the spinner to be properly placed in the center of the element you want the loading display to show over,
 * that element must have CSS position set to relative.
 *
 * [Props]
 * v-model: Show loading.
 */

export default {
  name: 'Loading',
  props: {
    loading: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped></style>
